import React from 'react'
import { Button, IconPosition } from '@at/design-system-elements'
import { FilterName } from '../../__generated__/fed-graphql-types'
import { IconEdit, IconReset } from '@at/design-system-icons'
import { useFilter } from '../../forms/hocs/filter.context.hoc'
import {
    StyledBoldTermsText,
    StyledResetToLowestMonthlyPriceButton,
    StyledTermsText,
    StyledTermsTitleText,
} from './leasing-terms-toggle.styles'
import {
    LEASING_SEARCH_CHEAPEST_SUMMARY_0_STATIC_COPY,
    LEASING_SEARCH_CHEAPEST_SUMMARY_1_STATIC_COPY,
    LEASING_SEARCH_CHEAPEST_SUMMARY_2_STATIC_COPY,
} from '@at/consumer-ui-text/lib/finance/shared/finance.shared.leasing'

export const EditTermsButton = () => {
    const { onValueChanged } = useFilter()
    const valueChangedProps = [
        { filter: FilterName.deposit, selected: ['6'] },
        { filter: FilterName.term, selected: ['36'] },
        {
            filter: FilterName.yearly_mileage,
            selected: ['8000'],
        },
    ]
    return (
        <Button
            displayType="secondary"
            iconSrc={<IconEdit title="edit terms" />}
            text="Edit terms"
            iconPosition={IconPosition.RIGHT}
            onClick={() => onValueChanged([], valueChangedProps)}
            fullWidth={true}
        />
    )
}

export const ResetToLowestMonthlyPriceButton = () => {
    const { onValueChanged } = useFilter()
    const valueChangedProps = [
        { filter: FilterName.deposit, selected: [] },
        { filter: FilterName.term, selected: [] },
        {
            filter: FilterName.yearly_mileage,
            selected: [],
        },
    ]
    return (
        <StyledResetToLowestMonthlyPriceButton
            displayType="tertiary"
            iconSrc={<IconReset title="reset to lowest monthly price" />}
            text="Reset to lowest monthly price"
            underline={true}
            onClick={() => onValueChanged([], valueChangedProps)}
        ></StyledResetToLowestMonthlyPriceButton>
    )
}

export const DefaultTermsText = () => {
    return (
        <>
            <StyledTermsTitleText>Terms</StyledTermsTitleText>
            <StyledTermsText>
                {LEASING_SEARCH_CHEAPEST_SUMMARY_0_STATIC_COPY}
                <StyledBoldTermsText>{LEASING_SEARCH_CHEAPEST_SUMMARY_1_STATIC_COPY}</StyledBoldTermsText>
                {LEASING_SEARCH_CHEAPEST_SUMMARY_2_STATIC_COPY}
            </StyledTermsText>
        </>
    )
}
